






























































































































































































































































































































































































































import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator';
import SeletorDeTag from '@/components/produto/SeletorDeTag.vue'
import SeletorDeMarca from '@/components/produto/SeletorDeMarca.vue'
import SeletorDeCategoria from '@/views/application/produtos/EdicaoDeProduto/SeletorDeCategoria.vue'
import SeletorDeEstacao from '@/components/produto/SeletorDeEstacao.vue';
import SeletorDeGenero from '@/components/produto/SeletorDeGenero.vue';
import { TabelaDePreco } from '@/models/TabelaDePrecos';
import AlertModule from '@/store/vuex/aplicacao/AlertModule';
import { DataOptions } from 'vuetify';
import Confirmacao from '@/components/ui/Confirmacao.vue';
import DataTableDeCrud from '@/components/ui/DataTableDeCrud.vue';
import axios, { CancelTokenSource } from 'axios';
import { FindImportacaoUseCase } from '@/usecases';
import { obterFiltroDeBuscaDeProdutosDefault } from '@/shareds/produto-shareds';
import { FiltroDeBuscaDeProdutos, LojaDoPdv, LojaTabelaPreco, ProdutoMarketplace } from '@/models';
import { obrigatorio } from '@/shareds/regras-de-form';
import CampoDePercentual from '@/components/ui/CampoDePercentual.vue';
import DatePicker from '@/components/ui/DatePicker.vue';
import SeletorDeTabelaDePreco from '@/components/tabeladepreco/SeletorDeTabelaDePreco.vue';
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore';
import SeletorDeLojas from '@/components/loja/SeletorDeLojas.vue';
import DialogoDeUploadDeArquivoParaBuscaDeProdutos from '../dialogosGenericos/DialogoDeUploadDeArquivoParaBuscaDeProdutos.vue';
import DialogoDeItemTabelaDePreco from '../tabela-de-precos/DialogoDeItemTabelaDePreco.vue';
import { FindProdutoMarketplaceUseCase } from '@/usecases/marketplace/FindProdutoMarketplaceUseCase';
import SeletorDeCategoriaGlobalMarketplace from '@/components/marketplace/SeletorDeCategoriaGlobalMarketplace.vue';
import DialogoProdutoMarketplace from '@/components/marketplace/DialogoProdutoMarketplace.vue';
import SeletorDeCanalDeVendaMarketplace from '@/components/marketplace/SeletorDeCanalDeVendaMarketplace.vue';
import type { CategoriaGlobalMarketplace, CanalVendaMarketplace, CanalVendaMarketplaceProduto, Loja, UnidadePlug4market, OrigemPlug4market, GeneroPlug4market } from '@/models';
import { FindItemDaTabelaDePrecoUseCase } from '@/usecases/tabela-de-precos/FindItemDaTabelaDePrecoUseCase';
import { UpdateProdutoMarketplaceUseCase } from '@/usecases/marketplace/UpdateProdutoMarketplaceUseCase';
import CardDeInformacoesDoProduto from '@/components/produto/CardDeInformacoesDoProduto.vue';
import { verificarQualidadeDoCadastro } from '@/shareds/marketplace-shareds';

@Component({
	components: {
		SeletorDeTag,
		SeletorDeMarca,
		SeletorDeCategoria,
		SeletorDeEstacao,
		SeletorDeGenero,
		DataTableDeCrud,
		CampoDePercentual,
		DatePicker,
		SeletorDeTabelaDePreco,
		SeletorDeLojas,
		DialogoDeUploadDeArquivoParaBuscaDeProdutos,
		SeletorDeCategoriaGlobalMarketplace,
		DialogoProdutoMarketplace,
		SeletorDeCanalDeVendaMarketplace,
		CardDeInformacoesDoProduto,
	},
})
export default class DialogoDeEdicaoEmMassaProdutosMarketplace extends Vue {
	@Ref() dialogo!: DialogoDeItemTabelaDePreco
	@Ref() confirmacao!: Confirmacao
	@Prop({ type: String }) lojaId!: string | undefined
	@Prop({ type: Object }) loja!: Loja | undefined
	@Ref() dialogoDeUploadDeArquivoParaBuscaDeProdutos!: DialogoDeUploadDeArquivoParaBuscaDeProdutos
	@Ref() dialogoProdutoMarketplace!: DialogoProdutoMarketplace
	@Ref() seletorDeCanalDeVendaMarketplace!: SeletorDeCanalDeVendaMarketplace

	findProdutosMarketplaceUseCase = new FindProdutoMarketplaceUseCase()
	updateProdutosMarketplaceUseCase = new UpdateProdutoMarketplaceUseCase()
	findProdutosUseCase = new FindImportacaoUseCase()
	findItemTabelaDePrecoUseCase = new FindItemDaTabelaDePrecoUseCase()
	filtro = obterFiltroDeBuscaDeProdutosDefault()
	obrigatorio = obrigatorio
	canalSelecionado: CanalVendaMarketplace | null = null
	tipoAnuncioCanalSelecionado: 'Clássico' | 'Premium' | null = null

	mostra = false
	produtosMarketplace: ProdutoMarketplace[] = []
	AlertModule = AlertModule
	headers = [
		{ text: 'Status', value: 'statusCadastro', sortable: false, width: '120px' },
		{ text: 'Produto', value: 'produto.nome', sortable: false },
		{ text: 'SKU', value: 'produto.sku', sortable: false },
		{ text: 'Ações', value: 'acoes', sortable: false, width: '120px' },
	]
	loading = false
	aplicandoConfiguracoes = false
	paginacao: DataOptions = {
		page: 1,
		itemsPerPage: 5,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}
	totalDeRegistros = -1
	filtroStatusCadastro: 'COMPLETO' | 'VERIFICAR' | 'INCOMPLETO' | null = null
	indice: number | null = null
	cancelToken: CancelTokenSource | null = null
	busca: FiltroDeBuscaDeProdutos[] = []
	modo = 'visualizar';
	parametrosEdicaoEmMassa: {
		tabelaDePreco: TabelaDePreco | null
		categoriaGlobal: CategoriaGlobalMarketplace | null
		unidade: string | null
		origem: string | null
		genero: string | null
		canaisVenda: CanalVendaMarketplaceProduto[] | null
		sincronizar: boolean | null
		comprimento: number | null
		peso: number | null
		largura: number | null
		altura: number | null
	} = {
		tabelaDePreco: null,
		categoriaGlobal: null,
		unidade: null,
		origem: null,
		genero: null,
		canaisVenda: null,
		sincronizar: null,
		comprimento: null,
		peso: null,
		largura: null,
		altura: null,
	}
	unidadesPossiveis = [
		'Unidade',
		'Quilogramas',
		'Gramas',
		'Miligramas',
		'Metros',
		'Centimetros',
		'Centimetros Quadrados',
		'Centimetros Cubicos',
		'Milimetros',
		'Milimetros Quadrados',
		'Milimetros Cubicos',
		'Libras',
		'Pes',
		'Pes Quadrados',
		'Pes Cubicos',
		'Polegadas',
		'Polegadas Quadradas',
		'Polegadas Cubicas',
		'Caixa',
	]
	generosPossiveis = [
		'masculino',
		'feminino',
		'menino',
		'menina',
		'unissex',
	]
	opcoesSincronizacao = [
		{tipo: 'Sincronizar', sinc: true},
		{tipo: 'Não Sincronizar', sinc: false},
	]
	opcoesFiltroSinconizadosMarketplace = [
		{tipo: 'Sincronizados', sinc: true},
		{tipo: 'Não Sincronizados', sinc: false},
	]
	origensPossiveis = ['Nacional', 'Importado']
	tabelaDeManutencao: TabelaDePreco | null = null
	aplicarSomenteComProdutosEmEstoque = false
	aplicarSomenteEmProdutosMarketplace: boolean | null = null
	lojasDaTabela: LojaDoPdv[] = []
	listaLojaTabelaPreco: LojaTabelaPreco[] = []
	findImportacaoUseCase = new FindImportacaoUseCase

	async mostrar(){
		this.mostra = true
	}

	cancelar(){
		this.modo = 'visualizar'
		this.limpaForms()
		this.limparListaProdutosMarketplace()
		this.mostra = false
	}

	@Watch('mostra')
	aoFecharDialogo(mostra: boolean) {
		if (!mostra) {
			this.limparListaProdutosMarketplace()
		}
	}

	limparListaProdutosMarketplace() {
		this.produtosMarketplace = []
		this.totalDeRegistros = -1
		this.paginacao.page = 1
	}

	async aplicarManutencao(){
		if (this.cancelToken) this.cancelToken.cancel()
		if(!this.lojaId) return
		if(this.produtosMarketplace.length < 1){
			this.modo = 'configurar'
			AlertModule.setError('Sem produtos filtrados para manutenção!')
			return
		}
		if(!this.usuario?.id) return

		try {
			this.loading = true;
			this.cancelToken = axios.CancelToken.source();

			await this.updateProdutosMarketplaceUseCase.updateEmMassa(this.produtosMarketplace)

			AlertModule.setSuccess(`Produtos marketplace atualizados com sucesso! Total de ${this.produtosMarketplace.length} produto(s) atualizado(s).`)
			
			this.produtosMarketplace = []
			this.mostra = false
			this.limpaForms()

		} catch (e) {
			if (axios.isCancel(e)) return
			AlertModule.setError(e)
		} finally {
			this.loading = false
			this.modo = 'visualizar'
		}
	}

	get listaFiltradaPorStatusCadastro() {
		if (!this.produtosMarketplace) return []
		if (!this.filtroStatusCadastro) return this.produtosMarketplace
		return this.produtosMarketplace.filter(p => p.statusCadastro === this.filtroStatusCadastro)
	}

	get totalRegistrosExibidos() {
		return this.listaFiltradaPorStatusCadastro.length
	}

	get produtosMarketplaceFormatados() {
		if (!this.produtosMarketplace) return []
		const inicio = (this.paginacao.page - 1) * this.paginacao.itemsPerPage
		const fim = inicio + this.paginacao.itemsPerPage
		return this.listaFiltradaPorStatusCadastro.slice(inicio, fim)
	}

	alternarFiltroStatusCadastro(status: 'COMPLETO' | 'VERIFICAR' | 'INCOMPLETO') {
		if (this.filtroStatusCadastro === status) {
			this.filtroStatusCadastro = null
		} else {
			this.filtroStatusCadastro = status
		}
		this.paginacao.page = 1
	}

	get contadoresStatus() {
		if (!this.produtosMarketplace) {
			return { completos: 0, verificar: 0, incompletos: 0 }
		}
		
		return {
			completos: this.produtosMarketplace.filter(p => p.statusCadastro === 'COMPLETO').length,
			verificar: this.produtosMarketplace.filter(p => p.statusCadastro === 'VERIFICAR').length,
			incompletos: this.produtosMarketplace.filter(p => p.statusCadastro === 'INCOMPLETO').length,
		}
	}

	getCorStatus(status: 'COMPLETO' | 'INCOMPLETO' | 'VERIFICAR' | undefined): string {
		switch (status) {
			case 'COMPLETO':
				return 'success'
			case 'VERIFICAR':
				return 'orange'
			case 'INCOMPLETO':
				return 'error'
			default:
				return 'grey'
		}
	}

	getLabelStatus(status: 'COMPLETO' | 'INCOMPLETO' | 'VERIFICAR' | undefined): string {
		switch (status) {
			case 'COMPLETO':
				return 'Completo'
			case 'VERIFICAR':
				return 'Verificar'
			case 'INCOMPLETO':
				return 'Incompleto'
			default:
				return 'N/A'
		}
	}

	async aplicarConfiguracoesNosItens() {
		this.aplicandoConfiguracoes = true
		
		try {
			if (!this.produtosMarketplace || this.produtosMarketplace.length === 0) {
				AlertModule.setWarning('Nenhum produto para aplicar alterações')
				return
			}

			const campos = this.parametrosEdicaoEmMassa
			const isValidNum = (v: number | null | undefined) => typeof v === 'number' && !isNaN(v)
			const temDimensoes = [campos.comprimento, campos.peso, campos.largura, campos.altura].some(isValidNum)
			const temCamposPreenchidos =
				!!campos.tabelaDePreco ||
				!!campos.categoriaGlobal ||
				!!campos.unidade ||
				!!campos.origem ||
				!!campos.genero ||
				(!!campos.canaisVenda && campos.canaisVenda.length > 0) ||
				campos.sincronizar !== null ||
				temDimensoes

			if (!temCamposPreenchidos) {
				AlertModule.setWarning('Preencha ao menos um campo para aplicar em massa')
				return
			}

			let precosPorProduto = new Map<string, number>()
			if (campos.tabelaDePreco && campos.canaisVenda && campos.canaisVenda.length > 0) {
				const chavePrecoProdutoMarketplace = (p: ProdutoMarketplace): string | null => {
					const idMarketplace = (p.id ?? '').trim()
					if (idMarketplace) return idMarketplace
					const idProduto = (p.produto?.id ?? '').trim()
					if (idProduto) return idProduto
					const idPrimeiraVariante = (p.variantes ?? [])
						.map(v => (v.produto?.id ?? '').trim())
						.find(Boolean)
					return idPrimeiraVariante ?? null
				}

				try {
					const produtosComId = this.produtosMarketplace.filter(p => p.produto?.id)
					
					const produtoIdsSet = new Set<string>()
					produtosComId.forEach(produto => {
						const temVariantes = produto.variantes && produto.variantes.length > 0
						if (temVariantes) {
							if (produto.produto?.id) {
								produtoIdsSet.add(produto.produto.id)
							}
							produto.variantes.forEach(variante => {
								if (variante.produto?.id) {
									produtoIdsSet.add(variante.produto.id)
								}
							})
						} else {
							if (produto.produto && produto.produto.id) {
								produtoIdsSet.add(produto.produto.id)
							}
						}
					})
					const produtoIds = [...produtoIdsSet]
					
					if (produtoIds.length > 0) {
						const precosPorProdutoId = await this.findItemTabelaDePrecoUseCase.buscarPrecosPorProdutos(
							campos.tabelaDePreco.id,
							produtoIds,
						)
						
						precosPorProduto = new Map<string, number>()
						produtosComId.forEach(produto => {
							const temVariantes = produto.variantes && produto.variantes.length > 0
							let preco: number | undefined
							
							if (temVariantes) {
								if (produto.produto?.id) {
									const precoPai = precosPorProdutoId.get(produto.produto.id)
									if (precoPai !== undefined && precoPai !== null && precoPai > 0) {
										preco = precoPai
									}
								}

								for (const variante of produto.variantes) {
									if (preco !== undefined && preco > 0) break
									if (variante.produto?.id) {
										const precoVariante = precosPorProdutoId.get(variante.produto.id)
										if (precoVariante !== undefined && precoVariante !== null && precoVariante > 0) {
											preco = precoVariante
											break
										}
									}
								}
							} else {
								if (produto.produto && produto.produto.id) {
									preco = precosPorProdutoId.get(produto.produto.id)
								}
							}
							
							if (preco !== undefined && preco !== null && preco > 0) {
								const chave = chavePrecoProdutoMarketplace(produto)
								if (chave) {
									precosPorProduto.set(chave, preco)
								}
							}
						})
					}
				} catch (error) {
					AlertModule.setWarning('Erro ao buscar preços da tabela. Os canais serão aplicados sem preços.')
				}
			}

			this.produtosMarketplace = this.produtosMarketplace.map(produto => {
				const atualizado: ProdutoMarketplace = {
					...produto,
					unidade: produto.unidade,
					origem: produto.origem,
					genero: produto.genero,
				}

				if (campos.tabelaDePreco) {
					atualizado.tabelaDePreco = campos.tabelaDePreco ? { ...campos.tabelaDePreco } : null
				}
				if (campos.categoriaGlobal) {
					atualizado.categoriaGlobal = {
						idExterno: campos.categoriaGlobal.idExterno,
						subCategoria: campos.categoriaGlobal.subCategoria,
						categoriaCompleta: campos.categoriaGlobal.categoriaCompleta,
					}
				}
				if (campos.unidade !== null && campos.unidade !== undefined && campos.unidade !== '') {
					atualizado.unidade = campos.unidade as UnidadePlug4market
				}
				if (campos.origem !== null && campos.origem !== undefined && campos.origem !== '') {
					atualizado.origem = campos.origem as OrigemPlug4market
				}
				if (campos.genero !== null && campos.genero !== undefined && campos.genero !== '') {
					atualizado.genero = campos.genero as GeneroPlug4market
				}
				const num = (v: number | null | undefined) => typeof v === 'number' && !isNaN(v) ? v : null
				const comprimento = num(campos.comprimento)
				const peso = num(campos.peso)
				const largura = num(campos.largura)
				const altura = num(campos.altura)
				if (comprimento != null) atualizado.comprimento = comprimento
				if (peso != null) atualizado.peso = peso
				if (largura != null) atualizado.largura = largura
				if (altura != null) atualizado.altura = altura
				if (campos.canaisVenda && campos.canaisVenda.length > 0) {
					const chave = (() => {
						const idMarketplace = (produto.id ?? '').trim()
						if (idMarketplace) return idMarketplace
						const idProduto = (produto.produto?.id ?? '').trim()
						if (idProduto) return idProduto
						const idPrimeiraVariante = (produto.variantes ?? [])
							.map(v => (v.produto?.id ?? '').trim())
							.find(Boolean)
						return idPrimeiraVariante ?? null
					})()
					const precoDoProduto = chave ? precosPorProduto.get(chave) : undefined
					const temPreco = precoDoProduto !== undefined && precoDoProduto > 0
				
					if (!temPreco && campos.tabelaDePreco) {
						atualizado.statusCadastro = 'INCOMPLETO'
						!atualizado.motivos ? atualizado.motivos = 
						['Produto sem preço na tabela de preço']
							:
							atualizado.motivos.push('Produto sem preço na tabela de preço')
						atualizado.sincronizar = false
					}
				
					const canaisExistentes = (atualizado.canaisVenda && atualizado.canaisVenda.length > 0)
						? [...atualizado.canaisVenda]
						: (produto.canaisVenda && produto.canaisVenda.length > 0)
							? [...produto.canaisVenda]
							: []
				
					const novosCanais = campos.canaisVenda.map(c => ({
						...c,
						canal: c.canal ? { ...c.canal } : null,
						preco: precoDoProduto !== undefined ? precoDoProduto : 0,
					}))
				
					novosCanais.forEach(novoCanal => {
						const indiceCanalExistente = canaisExistentes.findIndex(
							canalExistente => canalExistente.canal?.codigo === novoCanal.canal?.codigo,
						)
						if (indiceCanalExistente >= 0) {
							const canalExistente = canaisExistentes[indiceCanalExistente]
							const precoAtualizado = precoDoProduto !== undefined
								? precoDoProduto
								: canalExistente.preco
							canaisExistentes[indiceCanalExistente] = {
								...canalExistente,
								preco: precoAtualizado,
								tipoAnuncio: novoCanal.tipoAnuncio ?? canalExistente.tipoAnuncio,
							}
						} else {
							canaisExistentes.push(novoCanal)
						}
					})
				
					atualizado.canaisVenda = canaisExistentes
				}

				if (campos.sincronizar !== null) {
					atualizado.sincronizar = atualizado.statusCadastro === 'INCOMPLETO'
						? false
						: campos.sincronizar
				}

				const verificacao = verificarQualidadeDoCadastro(atualizado)
				if (verificacao.completo === false) {
					atualizado.statusCadastro = 'INCOMPLETO'
					atualizado.sincronizar = false
					atualizado.motivos = verificacao.motivos
				} else if (verificacao.completo === true) {
					atualizado.motivos = null
					atualizado.statusCadastro = 'COMPLETO'
				} else {
					atualizado.statusCadastro = 'VERIFICAR'
					atualizado.motivos = verificacao.motivos
				}

				atualizado.statusSincronizacao = 'Pendente'

				return atualizado
			})

			AlertModule.setSuccess('Configurações aplicadas na lista. Salve para confirmar.')
			
			this.parametrosEdicaoEmMassa.tabelaDePreco = null
			this.parametrosEdicaoEmMassa.categoriaGlobal = null
			this.parametrosEdicaoEmMassa.unidade = null
			this.parametrosEdicaoEmMassa.origem = null
			this.parametrosEdicaoEmMassa.genero = null
			this.parametrosEdicaoEmMassa.canaisVenda = null
			this.parametrosEdicaoEmMassa.sincronizar = null
			this.parametrosEdicaoEmMassa.comprimento = null
			this.parametrosEdicaoEmMassa.peso = null
			this.parametrosEdicaoEmMassa.largura = null
			this.parametrosEdicaoEmMassa.altura = null
			this.canalSelecionado = null
			this.tipoAnuncioCanalSelecionado = null
			
			this.modo = 'visualizar'
		} finally {
			this.aplicandoConfiguracoes = false
		}
	}

	get temProdutosIncompletos(): boolean {
		return this.produtosMarketplace.some(p => p.statusCadastro === 'INCOMPLETO')
	}

	aplicarIndice(indice: number) {
		this.indice = indice
		this.confirmacao.mostrar()
	}

	@Watch('produtosMarketplace', { deep: true })
	onProdutosMarketplaceChanged() {
		if (this.temProdutosIncompletos && this.parametrosEdicaoEmMassa.sincronizar === true) {
			this.parametrosEdicaoEmMassa.sincronizar = false
		}
	}

	get usuario() {
		return UserLoginStore.usuario
	}

	async buscarProdutosMarketplace() {
		if (this.cancelToken) this.cancelToken.cancel()
		if(!this.lojaId) return
		this.modo = 'visualizar'
		if(!this.usuario) return

		if (this.filtro.skus.length === 0
				&& this.filtro.categorias.length === 0
				&& this.filtro.tags.length === 0
				&& this.filtro.marcas.length === 0
				&& this.filtro.estacao.length === 0
				&& this.filtro.genero.length === 0
				&& this.aplicarSomenteComProdutosEmEstoque === false
				&& this.aplicarSomenteEmProdutosMarketplace === null
		) {
			AlertModule.setWarning('Preencha pelo menos um filtro para buscar produtos marketplace')
			return
		}

		try {
			this.loading = true
			this.cancelToken = axios.CancelToken.source()
			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}

			const filtro = JSON.parse(JSON.stringify(this.filtro));
			const params = {
				skus: filtro.skus,
				categorias: filtro.categorias,
				tags: filtro.tags,
				marcas: filtro.marcas,
				estacoes: this.filtro.estacao,
				genero: this.filtro.genero === null ? null : filtro.genero.id,
				aplicarSomenteComProdutosEmEstoque: this.aplicarSomenteComProdutosEmEstoque,
				aplicarSomenteEmProdutosMarketplace: this.aplicarSomenteEmProdutosMarketplace,
			};

			const protudosEncontrados = await this.findProdutosMarketplaceUseCase.findAllEdicaoEmMassa(
				this.lojaId,
				params,
				axiosConfig,
			);

			this.produtosMarketplace = protudosEncontrados.map(produto => {
				const verificacao = verificarQualidadeDoCadastro(produto)
				if (verificacao.completo === false) {
					produto.statusCadastro = 'INCOMPLETO'
					produto.sincronizar = false
					produto.motivos = verificacao.motivos
				} else if (verificacao.completo === true) {
					produto.motivos = null
					produto.statusCadastro = 'COMPLETO'
				} else {
					produto.statusCadastro = 'VERIFICAR'
					produto.motivos = verificacao.motivos
				}
				return produto
			})

			this.totalDeRegistros = protudosEncontrados.length
			this.produtosMarketplace = protudosEncontrados
			this.filtroStatusCadastro = null
			this.paginacao.page = 1
		} catch (e) {
			if (axios.isCancel(e)) return
			AlertModule.setError(e)
		} finally {
			this.loading = false
		}
	}

	limpaForms(){
		this.filtro.skus = []
		this.filtro.categorias = []
		this.filtro.tags = []
		this.filtro.marcas = []
		this.filtro.estacao = []
		this.filtro.genero = []
		this.parametrosEdicaoEmMassa.tabelaDePreco = null
		this.parametrosEdicaoEmMassa.categoriaGlobal = null
		this.parametrosEdicaoEmMassa.unidade = null
		this.parametrosEdicaoEmMassa.origem = null
		this.parametrosEdicaoEmMassa.genero = null
		this.parametrosEdicaoEmMassa.canaisVenda = null
		this.parametrosEdicaoEmMassa.sincronizar = null
		this.parametrosEdicaoEmMassa.comprimento = null
		this.parametrosEdicaoEmMassa.peso = null
		this.parametrosEdicaoEmMassa.largura = null
		this.parametrosEdicaoEmMassa.altura = null
		this.canalSelecionado = null
		this.tipoAnuncioCanalSelecionado = null
	}

	abrirDialogoEdicaoIndividual(produtoMarketplace: ProdutoMarketplace) {
		if (!this.loja && !this.lojaId) {
			AlertModule.setError('Loja não informada')
			return
		}

		const lojaParaEdicao = this.loja || { id: this.lojaId } as Loja
		this.dialogoProdutoMarketplace.mostrar(produtoMarketplace, lojaParaEdicao, true, false)
	}

	atualizarProdutoNaLista(produtoMarketplaceAtualizado: ProdutoMarketplace) {
		const index = this.produtosMarketplace.findIndex(p => p.id === produtoMarketplaceAtualizado.id)
		if (index >= 0) {
			this.produtosMarketplace.splice(index, 1, produtoMarketplaceAtualizado)
		}
	}

	onCanalSelecionado(canal: CanalVendaMarketplace | null) {
		if (canal) {
			this.tipoAnuncioCanalSelecionado = null
		}
	}

	isMercadoLivre(canal: CanalVendaMarketplace | null): boolean {
		return canal?.codigo === '7'
	}

	adicionarCanalALista() {
		if (!this.canalSelecionado) {
			return
		}

		if (!this.parametrosEdicaoEmMassa.canaisVenda) {
			this.parametrosEdicaoEmMassa.canaisVenda = []
		}

		const canalJaExiste = this.parametrosEdicaoEmMassa.canaisVenda.some(
			canal => canal.canal?.codigo === this.canalSelecionado?.codigo,
		)

		if (canalJaExiste) {
			AlertModule.setWarning(`O canal ${this.canalSelecionado.nome} já foi adicionado.`)
			return
		}

		const novoCanal: CanalVendaMarketplaceProduto = {
			id: '',
			canal: this.canalSelecionado,
			preco: 0,
			tipoAnuncio: this.isMercadoLivre(this.canalSelecionado) ? this.tipoAnuncioCanalSelecionado : null,
		}

		this.parametrosEdicaoEmMassa.canaisVenda.push(novoCanal)

		this.canalSelecionado = null
		this.tipoAnuncioCanalSelecionado = null

		if (this.seletorDeCanalDeVendaMarketplace) {
			this.seletorDeCanalDeVendaMarketplace.canaisJaCadastrados = 
				this.parametrosEdicaoEmMassa.canaisVenda
					.map(c => c.canal)
					.filter((c): c is CanalVendaMarketplace => c !== null)
		}
	}

	removerCanalDeVenda(index: number) {
		if (this.parametrosEdicaoEmMassa.canaisVenda) {
			this.parametrosEdicaoEmMassa.canaisVenda.splice(index, 1)
			if (this.parametrosEdicaoEmMassa.canaisVenda.length === 0) {
				this.parametrosEdicaoEmMassa.canaisVenda = null
			}
		}
	}

	abrirDialogoDeBuscaDeProdutosPorCsv(){
		this.dialogoDeUploadDeArquivoParaBuscaDeProdutos.mostrar()
	}

	preencherProdutosBuscados(produtos) {
		this.filtro.skus.push(...produtos);
	}
}
